import { Box, CardMedia } from '@mui/material'
import React from 'react'
// import { Link } from 'react-router-dom'
import cov1 from "../../assets/QataMap.jpeg"

function ContactDetails() {
    return (
        <Box sx={{ width: { md: "100%", xs: "100%" } }}>


            <CardMedia
                sx={{
                    height: { md: 700, xs: 300 },
                    // borderBottomLeftRadius: "20px",
                    width: "100%",
                    // borderBottomRightRadius: "20px",
                    objectFit: "fill",
                }}
                component="img"
                alt="green iguana"
                image={cov1}
            />
        </Box>
    )
}

export default ContactDetails